import { Controparte } from './controparte';
import { DocumentoAllegato } from './documento-allegato';
import { Parte } from './parte';
import { Categoria } from './tipologiche/categoria';

export class AltraParte {
  id: string;
  parte: Parte;
  categoriaAltraParte: Categoria;
  dataAssociazione: number = + new Date()
  dataTermine: number;
  rimosso: boolean;
  cliente: boolean;
  ritirato: boolean;
  documenti: DocumentoAllegato[];
  note: string;
  controparte: Controparte;
}
